import * as React from 'react'
import Menu from '@mui/material/Menu'
import { Drawer, IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined'
import { Box } from '@mui/system'
import { useState } from 'react'
import useStyles from './useStyles'
import RestoreModal from '../../../../components/Modals/Storage/RestoreModal'
import StepFileDetails from '../../../../components/Modals/Storage/RightModals/FileDetails'

export default function ModalMenuItem ({ item, setLoading }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const [stateSeeMore, setstateSeeMore] = useState(false)
  const classes = useStyles()

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const listSeeMoreOrganization = (anchor) => (
    <Box className={classes.stepperStyleSeeMore} role="presentation">
      <StepFileDetails
        setstateSeeMore={setstateSeeMore}
        item={item}
        setLoading={setLoading}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickMenu}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          item={item}
          onClose={handleClose}
          setstateSeeMore={setstateSeeMore}
        />
      </Menu>

      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMoreOrganization('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({ item, onClose, setstateSeeMore }) {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)

  return (
    <Box className={classes.boxStyle}>
      <IconButton
        onClick={() => {
          setstateSeeMore(true)
          onClose()
        }}
      >
        {' '}
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>

      <IconButton onClick={handleOpen}>
        <Box className={classes.boxTypography}>
          <RestoreOutlinedIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Restaurar documento
          </Typography>
        </Box>
      </IconButton>

      <RestoreModal open={open} setOpen={setOpen} ids={[item.documentId]} />
    </Box>
  )
}
